import {AuthorizationUtils} from "../../utils/AuthorizationUtils";
import {CREDIT_CARD_PAYMENT_INSTRUMENT_TYPE} from "../../app/AppConstants";


export const cofUnscheduled = (selectedCofType, config, finish, receive) => {
  return {
    execFunction: (error, paymentInstrument) => {
      console.log('Error/Result:', error, paymentInstrument);
      if (error || (paymentInstrument && paymentInstrument.origin !== 'creditcard')) {
        receive(error, paymentInstrument);
        finish();
        return;
      }

      let threeDsVersionResult = null;

      const doCardCheck = (result, threeDsAuthenticationId) => {
        const authId = threeDsAuthenticationId || null;
        window.PayEngine.cardCheck(paymentInstrument.paymentInstrumentId, selectedCofType, 'ECOM', authId, () => {
          fetch(`${config.api.baseUrl}/payment-instruments/${paymentInstrument.paymentInstrumentId}`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': AuthorizationUtils.base64(config.environment.merchantId, config.environment.apiKey)
            }
          })
          .then(response => response.json())
          .then(response => {
            receive(error, paymentInstrument, null, result, response);
            finish();
          });
        });
      };

      const onThreeDsAuthenticationResult = (error, result) => {
        console.log('threeDsAuthenticationResult: ', error, result);
        if (error) {
          receive(error, paymentInstrument, null, result, null);
          finish();
          return;
        }

        doCardCheck(result, result.id);
      };

      const browserInfoCallback = (error, result) => {
        console.log('browserInfoCallback: ', error, result);
        const parameters = {
          transactionData: {
            amount: 100,
            currency: 'EUR'
          },
          browserInfoId: result.browserInfoId,
          type: 'RECURRING_CARDCHECK',
          async: {
            notificationUrl: 'http://notification.example',
            successUrl: 'http://success.example',
            failureUrl: 'http://failure.example',
          }
        };
        window.PayEngine.threeDsAuthenticationRequest(paymentInstrument.paymentInstrumentId, threeDsVersionResult.id, parameters, onThreeDsAuthenticationResult);
      };

      const invokeMethodUrlCallback = () => {
        console.log('invokeMethodUrlCallback:');
        window.PayEngine.getBrowserInfo(browserInfoCallback);
      };

      const onThreeDsVersionCallback = (error, result) => {
        console.log('onThreeDsVersionCallback: ', error, result);
        threeDsVersionResult = result;
        if (result === null) {
          console.log('3Ds authentication result is empty');
          return;
        };

        if (result.version === '2.0') {
          if (result.specificData && result.specificData.methodUrl) {
            window.PayEngine.invokeMethodUrl(result.specificData.methodUrl, result.specificData.base64EncodedThreeDsMethodData, 'containre-id', invokeMethodUrlCallback);
          } else {
            invokeMethodUrlCallback();
          }
        } else if (result.version === null)  {
          doCardCheck(result);
        } else {
          receive(error, paymentInstrument);
          finish();
        }
      };

      if (error) {
        receive(error, paymentInstrument);
        finish();
      } else {
        if (paymentInstrument.type === CREDIT_CARD_PAYMENT_INSTRUMENT_TYPE) {
          window.PayEngine.threeDsVersion(paymentInstrument.paymentInstrumentId, onThreeDsVersionCallback);
        } else {
          receive(error, paymentInstrument);
          finish();
        }
      }
    },
    visualizeFunction: () => {
      return `
function cofAgreementStateCallback(error, result) {
  console.log("cofAgreementStateCallback", error, result);

  //You need to assign the coAgreementState for future usage
  cofAgreementState = result;
}
      
function resultCallback(error, paymentInstrument) {
  console.log('Error/Result:', error, paymentInstrument);

  var threeDsVersionResult = null;

  function onThreeDsAuthenticationResult(error, threeDsAuthenticationResult) {
    if (error) {
      //something went wrong;
      return;
    }
    
    window.PayEngine.cardCheck(paymentInstrument.paymentInstrumentId, cofType, 'ECOM', threeDsAuthenticationResult.id, function() {
      //Optionally you can call ${config.api.baseUrl}/payment-instruments/{paymentInstrument.paymentInstrumentId}
      //in order to get the final version of the payment instrument, including the newly created COF contract
    });
  }
  
  function browserInfoCallback(error, result) {
    if (error) {
      //browserInfo call failed
      return;
    }
    var parameters = {
      transactionData: {
        amount: 100,
        currency: 'EUR'
      },
      browserInfoId: result.browserInfoId,
      type: 'RECURRING_CARDCHECK',
      async: {
        notificationUrl: 'http://notification.example',
        successUrl: 'http://success.example',
        failureUrl: 'http://failure.example'
      }
    };
    
    window.PayEngine.threeDsAuthenticationRequest(paymentInstrument.paymentInstrumentId, threeDsVersionResult.id, parameters, onThreeDsAuthenticationResult);
  }

  function invokeMethodUrlCallback() {
    window.PayEngine.getBrowserInfo(browserInfoCallback);
  }

  function onThreeDsVersionCallback(error, result) {
    threeDsVersionResult = result;
    if (result.version === '2.0') {
      if (result.specificData && result.specificData.methodUrl) {
        window.PayEngine.invokeMethodUrl(result.specificData.methodUrl, result.specificData.base64EncodedThreeDsMethodData, 'inline-widget-container', invokeMethodUrlCallback);
      } else {
        invokeMethodUrlCallback();
      }
    } else if (result.version === null)  {
      window.PayEngine.cardCheck(paymentInstrument.paymentInstrumentId, cofType, 'ECOM', null, function() {
        //Optionally you can call ${config.api.baseUrl}/payment-instruments/{paymentInstrument.paymentInstrumentId}
        //in order to get the final version of the payment instrument, including the newly created COF contract
      });
    } else {
      //3DS version is not 2
    }
  }

  if (error) {
    //Something went wrong with the creation of a payment instrument
  } else {
    if (paymentInstrument.type === 'creditcard') {
      window.PayEngine.threeDsVersion(paymentInstrument.paymentInstrumentId, onThreeDsVersionCallback);
    } else {
      //The type of the created payment instrument is not 'creditcard'
    }
  }
}
    `;
    }
  };
};



// WEBPACK FOOTER //
// ./src/bridge/cof/Unscheduled.js